import { Fragment } from 'react';
import { node, arrayOf, oneOfType, string } from 'prop-types';
import classnames from 'classnames';

import styles from './Title.scss';

export const Title = ({ children = null, className, ...props }) => (
  <h2 className={classnames(styles.Title, className)} {...props}>
    {children}
  </h2>
);

export const TitleWithSubtitle = ({ title, className, children = null, ...props }) => (
  <Fragment>
    <Title className={className} {...props}>
      {title}
    </Title>
    {children}
  </Fragment>
);

Title.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  className: string,
};

TitleWithSubtitle.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
  className: string,
  title: string.isRequired,
};
